import DAppFooter from './DAppFooter'

export default DAppFooter
